import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { usePushNotificationList } from './hooks';
import { convertToPresentationProps } from './logics';
import { PushNotificationListPresentation } from './presentations';
import { PushNotificationListEmptyPresentation } from './presentations/empty';

/**
 * プッシュ通知一覧 Container
 *
 * - 状態管理・アクションは usePushNotificationList に委譲する
 * - API 型 → Presentation 型の変換は convertToPresentationProps に委譲する
 * - Empty / 通常表示の出し分けは isEmpty フラグで行う（三項演算子）
 *
 * NOTE: 親コンポーネント（Screen）で Suspense にラップすること
 */
export const PushNotificationList: React.FC = () => {
  const {
    state: { notificationsData, currentPage, totalPage, totalCount },
    actions: { handlePageChange },
  } = usePushNotificationList();

  const { rows, isEmpty } = convertToPresentationProps({ notificationsData });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows,
    onPageChange: handlePageChange,
  });

  return isEmpty ? (
    <PushNotificationListEmptyPresentation />
  ) : (
    <PushNotificationListPresentation rows={rows} pagerProps={pagerProps} />
  );
};
